import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CartItemsExpiredNotification from 'bento-ordering/base/components/CartItemsExpiredNotification';
import { editCart } from 'bento-ordering/cart/actions';
import { closeNotificationModal } from 'bento-ordering/base/actions/notificationModals';

class CartItemsExpiredNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
  };

  handlePrimaryCta = () => {
    const { dispatch } = this.props;
    dispatch(editCart({ clear_cart: true }));
    dispatch(closeNotificationModal());
  };

  render() {
    const { closeModal } = this.props;
    return (
      <CartItemsExpiredNotification
        handlePrimaryCta={this.handlePrimaryCta}
        closeModal={closeModal}
      />
    );
  }
}

export default connect()(CartItemsExpiredNotificationContainer);
